import { render, staticRenderFns } from "./SectionsList.vue?vue&type=template&id=75065319&scoped=true&"
import script from "./SectionsList.vue?vue&type=script&lang=ts&"
export * from "./SectionsList.vue?vue&type=script&lang=ts&"
import style0 from "./SectionsList.vue?vue&type=style&index=0&id=75065319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75065319",
  null
  
)

export default component.exports